<script setup lang="ts">
defineProps<{
  heading: string;
  subtitle?: string | null;
  /** HTML id for in-page links (e.g. Read more anchor). */
  anchor_id?: string | null;
}>();
</script>

<template>
  <div class="block-central-heading" :id="anchor_id || undefined">
    <h2 class="block-central-heading__title">{{ heading }}</h2>
    <p v-if="subtitle" class="block-central-heading__subtitle">{{ subtitle }}</p>
  </div>
</template>

<style scoped>
/* Prototype Dashboard: first section uses pt-8 lg:pt-12 above section headings; same rhythm for every central heading. */
.block-central-heading {
  max-width: 896px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.block-central-heading__title {
  margin: 0;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.2;
  color: var(--color-text);
  font-size: 1.59rem;
}

@media (min-width: 640px) {
  .block-central-heading__title {
    font-size: 1.91rem;
  }
}

@media (min-width: 1024px) {
  .block-central-heading__title {
    font-size: 2.55rem;
  }
}

.block-central-heading__subtitle {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.5;
  color: var(--color-text-muted);
}
</style>
